var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThunder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.122 2.453h.026-.026zm0 0l-1.84 9.623 6.698.026-9.102 13.05 1.84-10.588-6.698-.025 9.102-12.086zm0-1.625h-.128a1.38 1.38 0 00-.358.089 2.086 2.086 0 00-.345.19 1.677 1.677 0 00-.345.305.199.199 0 00-.038.05.2.2 0 01-.039.052L.69 13.549c-.392.542-.434 1.109-.128 1.701.052.102.116.199.192.292.077.093.162.178.256.254.094.076.196.14.307.19a1.65 1.65 0 00.703.153l4.73.025-1.509 8.709c-.068.372-.008.724.18 1.054.187.33.451.571.792.723.102.051.209.085.32.102.11.017.226.025.345.025.494 0 .912-.22 1.253-.66l9.179-13.05c.392-.542.434-1.11.128-1.702-.307-.592-.793-.888-1.458-.888h-4.73l1.483-7.643a1.342 1.342 0 00.051-.38 1.43 1.43 0 00-.064-.433 1.837 1.837 0 00-.41-.71 1.319 1.319 0 00-.319-.254 1.938 1.938 0 00-.383-.165 1.373 1.373 0 00-.41-.064h-.076z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.39308f66.svg";
export { ForwardRef as ReactComponent };